import { dataPlusCircle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPlusCircle = /*#__PURE__*/createIcon(dataPlusCircle)
export default IconPlusCircle
